class Tab {
  stateClasses = {
    active: "tab__nav-item--active",
  };

  $activeTab = null;

  constructor($el) {
    this.$el = $el;
    this.$radio = $el.find('[data-tab="radio"]');
    this.$navItems = $el.find('[data-tab="nav-item"]');
    this.init();
  }

  init = () => {
    this.$radio.on("change", this.handleChange);
  };

  handleChange = (e) => {
    const activeTabId = $(e.target).attr("id");

    this.$navItems.removeClass(this.stateClasses.active);

    this.$activeTab = this.$navItems.filter((i, item) => {
      if (activeTabId == $(item).attr("for")) {
        return true;
      }
    });

    this.$activeTab.addClass(this.stateClasses.active);
    $(window).trigger("resize");
  };
}

export default Tab;
